import { useCallback, useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { ReactComponent as CloseIcon } from "../../assets/images/icons/ic-close.svg"
import { TestType } from "../../enums.js"
import DropdownSelection from "../DropdownSelection.js"
import TestChoice from "./TestChoice.js"
import Card from "../cards/Card.js"
import styles from "./TestForm.module.css"
import TestTrueFalse from "./TestTrueFalse.js"
import TestTextCompletion from "./TestTextCompletion.js"
import Select from "../Select.js"


const TestForm = ({
    testType = null,
    onRemove = () => { },
    innerTest = {},
    showRemoveButton,
    tagList = [],
    disabled = false,
    onChange = () => { }
}) => {
    const { t } = useTranslation()
    const [_testType, setTestType] = useState(testType)
    const [_innerTest, setInnerTest] = useState(innerTest)
    const [validationError, setValidationError] = useState("")

    const testTypes = useMemo(() => {
        return [
            { id: 0, value: TestType.SingleChoice, name: t("tests.testType.singleChoice") },
            { id: 1, value: TestType.MultipleChoice, name: t("tests.testType.multipleChoice") },
            { id: 2, value: TestType.TrueFalse, name: t("tests.testType.trueFalse") },
            { id: 3, value: TestType.TextCompletion, name: t("tests.testType.textCompletion.label") },
        ]
    }, [])

    const onInnerTestChange = useCallback((changes) => {
        const { validationError } = changes
        setValidationError(validationError)
        setInnerTest(changes)
    }, [])

    useEffect(() => {
        onChange({
            testType: _testType,
            innerTest: _innerTest
        })
    }, [_innerTest])

    useEffect(() => {
        setInnerTest({})
    }, [_testType])

    return (
        <Card appearance="modern" style={{
            width: "100%", backgroundColor: "var(--background-color)",
        }} error={validationError}>
            <div className={`${styles.cardContent} ${disabled ? styles.disabled : ""}`}>
                <div className={styles.header}>
                    <div className={styles.leftHeader}>
                        <div className={styles.testType}>
                            <Select appearance="modern" portal options={testTypes} selected={testTypes.find(c => c.value === _testType)} onSelect={(c) => {
                                setTestType(c.value)
                            }} />
                        </div>
                        {
                            validationError &&
                            <div className={styles.validationError}>
                                {validationError}
                            </div>
                        }
                    </div>
                    {
                        showRemoveButton &&
                        <button className={styles.closeButton} onClick={onRemove}>
                            <CloseIcon />
                        </button>
                    }
                </div>
                {
                    _testType === TestType.SingleChoice && <TestChoice tagList={tagList} {...innerTest} onChange={onInnerTestChange} singleChoice />
                }
                {
                    _testType === TestType.MultipleChoice && <TestChoice tagList={tagList} {...innerTest} onChange={onInnerTestChange} />
                }
                {
                    _testType === TestType.TrueFalse && <TestTrueFalse tagList={tagList} {...innerTest} onChange={onInnerTestChange} />
                }
                {
                    _testType === TestType.TextCompletion && <TestTextCompletion tagList={tagList} {...innerTest} onChange={onInnerTestChange} />
                }
            </div>
        </Card>
    )
}

export default TestForm
